import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { scrollToId } from "@/lib/scroll";

const NAV = [
  { label: "SERVICES", id: "services" },
  { label: "WORK", id: "work" },
  { label: "PROCESS", id: "process" },
  { label: "PRICING", id: "pricing" },
  { label: "REVIEWS", id: "reviews" },
  { label: "ABOUT", id: "about" },
  { label: "CONTACT", id: "contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), 350);
  };

  return (
    <>
      <header className="fixed inset-x-0 top-0 z-[80]">
        <div className="flex items-center justify-between bg-gradient-to-b from-black/85 via-black/40 to-transparent px-5 pb-8 pt-5 sm:px-10 sm:pt-7">
          <button
            data-testid="header-logo"
            onClick={() => go("hero")}
            className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-white"
          >
            JW. EDITS
          </button>
          <button
            data-testid="menu-button"
            onClick={() => setOpen(true)}
            className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-white transition-opacity hover:opacity-50"
          >
            MENU
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="menu-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="fixed inset-0 z-[100] flex flex-col bg-[#050505]"
          >
            <div className="flex items-center justify-between px-5 py-5 sm:px-10 sm:py-7">
              <span className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-[#8E8E93]">
                JW. EDITS
              </span>
              <button
                data-testid="menu-close-button"
                onClick={() => setOpen(false)}
                className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-white transition-opacity hover:opacity-50"
              >
                CLOSE
              </button>
            </div>
            <nav className="flex flex-1 flex-col justify-center px-5 sm:px-10">
              {NAV.map((item, i) => (
                <div key={item.id} className="overflow-hidden border-b border-white/10">
                  <motion.button
                    data-testid={`menu-nav-${item.id}`}
                    initial={{ y: "110%" }}
                    animate={{ y: 0 }}
                    transition={{ duration: 0.7, delay: 0.1 + i * 0.06, ease: [0.16, 1, 0.3, 1] }}
                    onClick={() => go(item.id)}
                    className="group flex w-full items-baseline gap-4 py-3 text-left sm:py-4"
                  >
                    <span className="font-mono text-[10px] tracking-[0.3em] text-[#8E8E93]">
                      0{i + 1}
                    </span>
                    <span className="font-display text-5xl font-black uppercase leading-none tracking-tight text-[#F3F3F5] transition-colors group-hover:text-[#E63946] sm:text-7xl">
                      {item.label}
                    </span>
                  </motion.button>
                </div>
              ))}
            </nav>
            <div className="flex items-center justify-between px-5 py-6 sm:px-10">
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8E8E93]">
                REAL-LIFE VIDEO EDITING — EST. 2026
              </span>
              <span className="hidden font-mono text-[10px] uppercase tracking-[0.3em] text-[#8E8E93] sm:block">
                JEREMIAH WOMACK
              </span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
